const SETUP_DISMISSED_PREFIX = 'tracker_ai_setup_dismissed:';

export function isProjectSetupDismissed(projectId: string): boolean {
  return localStorage.getItem(`${SETUP_DISMISSED_PREFIX}${projectId}`) === '1';
}

export function dismissProjectSetup(projectId: string): void {
  localStorage.setItem(`${SETUP_DISMISSED_PREFIX}${projectId}`, '1');
}

export function clearProjectSetupDismissed(projectId: string): void {
  localStorage.removeItem(`${SETUP_DISMISSED_PREFIX}${projectId}`);
}
